// src/App.jsx
import { createContext, useState, useEffect, useCallback } from 'react';
import keycloak, { initKeycloak } from './components/routing/Keycloak.js';
import AppRoutes from './components/routing/AppRoutes';
import Loading from './components/generic/loading';

export const subscriberContext = createContext();

const App = () => {
  const [sideBarFull, setSideBarFull] = useState(true);
  const [initialized, setInitialized] = useState(false);
  const [authError, setAuthError] = useState(null);

  const isCallback = useCallback(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('code') && urlParams.has('state');
  }, []);

  useEffect(() => {
    let mounted = true;

    const init = async () => {
      // If already initialized or in error state, don't proceed
      if (initialized || authError) return;

      try {
        // Clear any existing tokens first
        localStorage.removeItem('keycloak-token');
        sessionStorage.removeItem('keycloak-token');

        // Initialize Keycloak
        const authenticated = await initKeycloak();
        
        if (mounted) {
          if (authenticated) {
            setInitialized(true);
            // Clean up URL if this is a callback
            if (isCallback()) {
              window.history.replaceState({}, document.title, window.location.pathname);
            }
          }
        }
      } catch (error) {
        console.error('Auth error:', error);
        if (mounted) {
          setAuthError(error);
        }
      }
    };

    init();

    return () => {
      mounted = false;
    };
  }, [initialized, authError, isCallback]);

  if (authError) {
    return (
      <div className="container">
        <div>Authentication error occurred. Please refresh the page.</div>
      </div>
    );
  }

  if (!initialized) {
    return (
      <div className="container">
        <Loading />
      </div>
    );
  }

  return (
    <div className='container'>
      <subscriberContext.Provider
        value={{ 
          sideBarFull, 
          setSideBarFull,
          keycloak
        }}
      >
        <AppRoutes />
      </subscriberContext.Provider>
    </div>
  );
};

export default App;